import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@shared/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full font-normal py-1 px-2.5 text-xs transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border bg-gray-50 text-gray-800 hover:bg-gray-50/60',
        primary:
          'border border-primary-100 bg-primary-50 text-primary-800 hover:bg-primary-50/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground border',
        new_feature: "border border-teal-300 bg-teal-100 font-mono font-semibold text-teal-600",
      },
      size: {
        sm: 'py-0.5 px-2.5',
        md: 'py-1 px-3 ',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant, size }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
